// ホワイトリストに登録された大学コードの場合のみ GPS 機能を有効化
const CURRENT_CODE = (process.env.REACT_APP_UNIVERSITY_CODE ?? "")
  .trim()
  .toLowerCase();

const GPS_WHITELIST = (process.env.REACT_APP_GPS_WHITELIST ?? "")
  .split(",")
  .map((s) => s.trim().toLowerCase())
  .filter(Boolean);

export const USE_GPS = GPS_WHITELIST.includes(CURRENT_CODE);
